import React from 'react'
import PropTypes from 'prop-types'
import { T } from 'ramda'

import { useStyles } from './voucher-not-applicable.styles'
import exclamationWhiteSmall from '../../../../../images/exclamation-white-small.svg'
import Button from '../../../../components/button'

const VoucherNotApplicable = ({ error, goBack }) => {
  const styles = useStyles()

  return (
    <div className={styles.voucherContainer}>
      <div className={styles.iconFrame}>
        <img
          src={exclamationWhiteSmall}
          alt="exclamation"
        />
      </div>

      <div className={styles.title}>
        This voucher isn&apos;t valid for this Plan
      </div>

      <p className={styles.errorMessage}>
        {error}
      </p>

      <div className={styles.buttonContainer}>
        <Button
          onClick={() => goBack()}
          className={styles.button}
          text="Go Back"
        />
      </div>
    </div>
  )
}

VoucherNotApplicable.propTypes = {
  error: PropTypes.string.isRequired,
  goBack: PropTypes.func
}

VoucherNotApplicable.defaultProps = {
  goBack: T
}

export default VoucherNotApplicable
